module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-300italic.80150d91.ttf";